<template>
  <div class="addContractProtocol">
    <el-table
      ref="multipleTable"
      :data="contractScanVOs"
      border
      size="mini"
      style="width: 100%;margin-top:20px;"
      height="100%"
    >
      <el-table-column type="index" width="50" label="序号"></el-table-column>
      <el-table-column
        v-for="(item,index) in tableColumnDatas"
        :key="index"
        :prop="item.class"
        :label="item.labelName"
        :sortable="item.sortEnable"
        show-overflow-tooltip
      >
       <template slot-scope="scope">
          <div v-if="scope.column.property == 'status'">           
           {{props.row.status==2?'待审批':'已通过'}}
          </div>            
          <span v-else>{{scope.row[scope.column.property]}}</span>
         </template>
      </el-table-column>
       <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button @click="protocolDetail(scope.row)" type="text" size="small">查看详情</el-button>
          </template>
        </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: "addContractProtocol",
  props: {
    contractScanVOs: {
      type: Array
    },
    subServiceContractId:{
       type:Number
    }    
  },
  data() {
    return {
      tableColumnDatas: [
       { class: "serialNumber", labelName: "合同编号", sortEnable: false },
        { class: "name", labelName: "合同名称", sortEnable: false },
        { class: "projectName", labelName: "所属项目", sortEnable: false },
        { class: "partyB", labelName: "供应商", sortEnable: false },
        { class: "amount", labelName: "合同金额", sortEnable: false },
        { class: "applyUserName", labelName: "申请人", sortEnable: false },
        { class: "applyDeptName", labelName: "申请部门", sortEnable: false },
         { class: "approveStatusName", labelName: "状态", sortEnable: false },
        { class: "updateTime", labelName: "申请时间", sortEnable: false }
      ]
    };
  },
  methods:{
     //查看补充协议一条数据详情 gaa 20200811
    protocolDetail(row) {
      this.$confirm("确定要查看吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let memberData = {};
        memberData.id = row.id; //合同编号
         memberData.addFlag = 2; //新增标志为1，编辑为2
        memberData.pid=this.subServiceContractId;
         memberData.editFlag = true; //编辑追加协议标记
        this.bus.$emit("navMenuChange", {
          //跳转相应的分项合同
          routeId: "innerApproveDetail",
          routeParam: memberData
        });
      });
    },

  },
  watch: {
    engineerItems(newVal) {
      if (newVal.length > 0) {
        this.tableData = newVal;
      }
    }
  }
  
};
</script>
<style scoped >
/deep/.el-tabs__item {
  height: 56px;
  line-height: 56px;
  width: 160px;
  padding: 0 !important;
  font-size: 18px;
  color: #666666 !important;
}
/deep/.el-tabs__header {
  padding-right: 0;
}
>>> .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  background: #fff;
  color: #069dbc !important;
  border-bottom-color: #e4e7ed;
  padding: 0;
}
>>> .el-tabs__item:hover {
  color: #069dbc;
}
</style>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";
.el-container {
  padding-top: 0;
  .el-header {
    padding: 0;
    form {
      padding-right: 20px;
    }
  }
}
.addContractProtocol {
  height: 100%;
  background-color: white;
}
/deep/.el-tabs__header {
  padding-right: 0 !important;
  background: #d5e7ed !important;
}
.el-select {
  width: 100%;
}
.hide {
  display: none;
}

/deep/.overTimeMark {
  background-color: #e9f4fa;
  .el-tooltip {
    color: #333333;
  }
}

/deep/.el-form-item__content {
  width: 60%;
}
/deep/.el-form-item {
  width: 100%;
}
/deep/.el-date-editor {
  width: 100% !important;
}
</style>
